import { Field, Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import { useGetAllModelsList } from "../../Parameters/Equipment/Models/api/getAllModelsList";
import UnitsSelectionDropdown from "src/components/Common/UI/UnitsSelectionDropdown/UnitsSelectionDropdown";


const NodeForm = ({ initialValues , unitType }: NodeFormProps) => {
  const { t } = useTranslation();

  const getAllModelsListQuery = useGetAllModelsList();

  const validationSchema= Yup.object({
    description: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
  })

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values, formikHelpers) => {
        //onSubmit(values, formikHelpers);
      }}
      validationSchema={validationSchema}
    >
      {({ errors, touched, isSubmitting, values, setFieldValue }) => (
        <Form>
          <Container fluid className="p-0">
            <Row>
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Περιγραφή")}`}
                </label>
                <Field
                  name="description"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="description"
                />
                <div className="text-danger">
                  {errors.description && touched.description && (
                    <div>{errors.description}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Μοντέλο")}`}
                </label>
                <Field
                  as="select"
                  name="modelID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="modelID"
                >
                <option value="">{t("Επιλέξτε Μοντέλο")}</option>
                {getAllModelsListQuery.data &&
                  getAllModelsListQuery.data.map((model) => (
                    <option key={model.id} value={model.id}>
                      {model.description}
                    </option>
                  ))
                }    
                    
                </Field>
                <div className="text-danger">
                  {errors.modelID && touched.modelID && (
                    <div>{errors.modelID}</div>
                  )}
                </div>
              </Col>
              
              <UnitsSelectionDropdown errors={errors} touched={touched} unitType={unitType}/>
         
              <Col xs={6}>
                <label className="form-label">
                  {`${t("Hostname")}`}
                </label>
                <Field
                  name="hostName"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="hostName"
                />
                <div className="text-danger">
                  {errors.hostName && touched.hostName && (
                    <div>{errors.hostName}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Ταχ. Διεύθυνση")}`}
                </label>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Field
                    name="address"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="address"
                  /> 
                </div>
              </Col>

              <Col xs={6}></Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("x25NodeAddress")}`}
                </label>
                <Field
                  name="x25NodeAddress"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="x25NodeAddress"
                />
                <div className="text-danger">
                  {errors.x25NodeAddress && touched.x25NodeAddress && (
                    <div>{errors.x25NodeAddress}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("x25NodeNumber")}`}
                </label>
                <Field
                  name="x25NodeNumber"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="x25NodeNumber"
                />
                <div className="text-danger">
                  {errors.x25NodeNumber && touched.x25NodeNumber && (
                    <div>{errors.x25NodeNumber}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                  <label className="form-label">
                    {`${t("Εμπορική")}`}
                  </label>
                  <Field
                    type="checkbox"
                    name="isEmporiki"
                    field="isEmporiki"
                  />
                  <div className="text-danger">
                    {errors.isEmporiki && touched.isEmporiki && (
                      <div>{errors.isEmporiki}</div>
                    )}
                  </div>
                </Col>

                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Citibank")}`}
                  </label>
                  <Field
                    type="checkbox"
                    name="isCiti"
                    field="isCiti"
                  />
                  <div className="text-danger">
                    {errors.isCiti && touched.isCiti && (
                      <div>{errors.isCiti}</div>
                    )}
                  </div>
                </Col>

              <Col xs={6}>
                <label className="form-label">
                  {`${t("Αρχείο διαγράμματος")}`}
                </label>
                <Field
                  name="filepath"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="filepath"
                />
                <div className="text-danger">
                  {errors.filepath && touched.filepath && (
                    <div>{errors.filepath}</div>
                  )}
                </div>
              </Col>
            
            </Row>
          </Container>

          {/* <div className="mb-3">
            <Button
              type="submit"
              size="sm"
              styletype="primary"
              disabled={isSubmitting}
            >
              {type == "create" ? t("Δημιουργία") : t("Αποθήκευση")}
            </Button>
          </div> */}
        </Form>
    )}
  </Formik>
)
}
export default NodeForm;

type NodeFormProps =
   {
      initialValues: IEditNodeForm;
      unitType:string | undefined;
     /*  onSubmit: (
        values: ICreateNodeForm,
        formikHelpers: FormikHelpers<ICreateNodeForm>
      ) => void; */
    }